import { post, put, deleteReq } from './api';

export const addVote = ({ bookletId, sectionId, fragmentId, body }) =>
  post(
    `/booklets/${bookletId}/sections/${sectionId}/fragments/${fragmentId}/votes`,
    JSON.stringify(body),
    {
      'Content-Type': 'application/json',
    }
  );

export const deleteVote = ({ bookletId, sectionId, fragmentId }) =>
  deleteReq(
    `/booklets/${bookletId}/sections/${sectionId}/fragments/${fragmentId}/votes`,
    {
      'Content-Type': 'application/json',
    }
  );

export const updateVote = ({ bookletId, sectionId, fragmentId, body }) =>
  put(
    `/booklets/${bookletId}/sections/${sectionId}/fragments/${fragmentId}/votes`,
    JSON.stringify(body),
    {
      'Content-Type': 'application/json',
    }
  );

export const addShareVote = ({ body, token }) =>
  post(`/users/shared/votes?token=${token}`, JSON.stringify(body), {
    'Content-Type': 'application/json',
  });

export const deleteShareVote = ({ fragmentId, token }) =>
  deleteReq(`/users/shared/votes/${fragmentId}?token=${token}`, {
    'Content-Type': 'application/json',
  });

export const updateShareVote = ({ fragmentId, body, token }) =>
  put(
    `/users/shared/votes/${fragmentId}?token=${token}`,
    JSON.stringify(body),
    {
      'Content-Type': 'application/json',
    }
  );



// WEBPACK FOOTER //
// ./src/services/voteApi.js